import type { ProductPricingContext } from './pricing'

export const isSimplifiedStorefrontEnabled = () =>
  import.meta.env.VITE_SIMPLIFIED_STOREFRONT === '1'

export const shouldDelaySimplifiedStorefrontRender = (input: {
  isSiteConfigLoading: boolean
  publicPricingClienteId?: unknown
}) => {
  if (!isSimplifiedStorefrontEnabled() || !input.isSiteConfigLoading) return false

  const publicPricingClienteId = Number(input.publicPricingClienteId ?? 0)
  return !Number.isFinite(publicPricingClienteId) || publicPricingClienteId <= 0
}

export const isSimplifiedStorefrontPlaceholderPrice = (value: unknown) => {
  if (!isSimplifiedStorefrontEnabled()) return false

  const price = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(price) && price > 0 && price <= 0.01
}

export const requiresSimplifiedStorefrontProductConfiguration = (
  product: { hasForm?: boolean } | null | undefined
) => isSimplifiedStorefrontEnabled() && product?.hasForm === true

export const resolveSimplifiedStorefrontPricingContext = (
  context: ProductPricingContext
): ProductPricingContext => {
  if (!isSimplifiedStorefrontEnabled()) return context

  return {
    ...context,
    isLoggedIn: false,
    showPrices: true,
    document: null,
    stateRegistration: null,
    tipoPessoa: 1,
    markupPercentual: 0,
    distributionEnabled: false,
    distributionActive: false,
    distributionSpecial: false,
    distributionStatusResolved: true,
    distributionInfo: null,
  }
}

export const canUseAnonymousQuickCheckout = (input: {
  isLoggedIn: boolean
  isCartAuthenticated: boolean
  publicPricingEnabled: boolean
  simplifiedStorefrontEnabled: boolean
}) => (
  !input.isLoggedIn
  && !input.isCartAuthenticated
  && input.publicPricingEnabled
  && input.simplifiedStorefrontEnabled
)
